import React, {useState} from "react";
import styled from "styled-components";
import PasswordSection from "./PasswordSection";
import DeleteAccountSection from "./DeleteAccountSection";
import EditUserModal from "../modal/EditUserModal";
import {useSelector} from "react-redux";
import AuthVerificationForm from "../auth/AuthVerificationForm";
import {Link, useLocation} from "react-router-dom";
import {
    DELETE_ACCOUNT,
    PASSWORD,
    PROFILE_NAME_ROUTE,
    SECURITY,
} from "../../routes/routesName";
import {displayAlert} from "../../utils/utils";

const AccountSecurity = () => {

    const {isConfirmedStatus} = useSelector(state => state.auth)
    const location = useLocation()

    const [isErrors, setIsErrors] = useState(false)
    const [isSent, setIsSend] = useState(false)

    const {pathname} = useLocation()

    const BASE_ROUTE = SECURITY + "/"

    const filteredChoices = [
        {
            id: "profile",
            name: "Modifier mon profil",
            link: BASE_ROUTE + PROFILE_NAME_ROUTE
        },
        {
            id: "password",
            name: "Modifier mon mot de passe",
            link: BASE_ROUTE + PASSWORD
        },
        {
            id: "delete",
            name: "Supprimer mon compte",
            link: BASE_ROUTE + DELETE_ACCOUNT
        },
    ]


    const displaySections = () => {
        if (location.pathname.includes(PROFILE_NAME_ROUTE)) {
            return <EditUserModal
                isCurrentUser={true}
                setIsSend={setIsSend}
                setIsErrors={setIsErrors}
                setModalIsOpen={displayAlert}
            />
        }
        if (location.pathname.includes(PASSWORD)) {
            return <PasswordSection/>
        }
        if (location.pathname.includes(DELETE_ACCOUNT)) {
            return <DeleteAccountSection/>
        }
    }

    const displayIfAuth = () => {
        if (isConfirmedStatus === 0 || isConfirmedStatus !== 200) {
            return <AuthVerificationForm/>
        }

        if (isConfirmedStatus === 200) {
            return (
                <>
                    {displayAlert(isErrors, isSent)}
                    <Container>
                        <Menu>
                            {filteredChoices.map(choice => (
                                <Li
                                    to={choice.link}
                                    key={choice.id}
                                    className={`flex-row ${pathname.includes(choice.link) ? "user-selected green-border" : ""}`}
                                    ref={choice.reference}
                                    id={choice.id}
                                >
                                    <p> {choice.name}  </p>
                                </Li>
                            ))}
                        </Menu>
                        <Sections>
                            {displaySections()}
                        </Sections>
                    </Container>
                </>
            )
        }
    }
    return (
        <Section>
            {displayIfAuth()}
        </Section>
    )
}

const Section = styled.div`
  height: 100%;
  h1 {
    padding-left: 1rem;
  }

`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-left: 1rem;
  @media (min-width: 768px) {
    padding-left: 0;
    height: inherit;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`
const Li = styled(Link)`
  display: flex;
  line-height: 2rem;
  padding: 0 1rem;
  cursor: pointer;

  &:hover {
    background-color: var(--color-grey-03);
  }
`
const Menu = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin-top: 3rem;

  @media (min-width: 768px) {
    border-right: 1px solid var(--color-grey-06);
    min-width: 15rem;
    max-width: 15rem;
    height: 100%;
    margin: 0;
  }
`
const Sections = styled.div`
  height: 100%;
  width: 100%;
  @media (min-width: 768px) {
    padding-left: 1rem;
  }
`



export default AccountSecurity;